var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.152 2.117A.6.6 0 0 0 6 2.5h4a.6.6 0 0 0-.152-.383 1.3 1.3 0 0 0-.434-.324 2.7 2.7 0 0 0-.649-.217A4 4 0 0 0 8 1.5a4 4 0 0 0-.765.076c-.243.05-.464.124-.65.217a1.3 1.3 0 0 0-.433.324"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.75 4a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-.75v7.75A1.75 1.75 0 0 1 11 14.25H5a1.75 1.75 0 0 1-1.75-1.75V4.75H2.5A.75.75 0 0 1 1.75 4m3 8.5V4.75h6.5v7.75a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;